import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { hasPermission, isAdmin } from '../utils/permissions'

export default function PermissionRoute({ routePath, element }) {
  const [allowed, setAllowed] = useState(null) // null = still checking

  useEffect(() => {
    if (isAdmin()) {
      setAllowed(true)
      return
    }
    hasPermission(routePath).then(result => setAllowed(result))
  }, [routePath])

  if (allowed === null) return null
  return allowed ? element : <Navigate to="/Homepage" replace />
}
